import { useNavigate } from 'react-router-dom';

import { UseAlert } from '../../../presentation/hook/AlertHook';

import ChangePasswordPage from '../../../presentation/page/changePassword/ChangePasswordPage';

import { ForgotPasswordUseCase } from '../../../data/useCase/ForgotPasswordUseCase';
import { EndpointsConstant } from '../../../main/constant/EndpointConstant';

/**
 * ChangePasswordPageDomain - regra de negocio de troca senha
 * @constructor
 */
export const ChangePasswordPageDomain: React.FC = () => {
  /**
   * Alertas
   */
  const { showAlert } = UseAlert();

  /**
   * navegacao da url
   */
  const navigate = useNavigate();

  const ENDPOINT_FORGOT_PASSWORD = EndpointsConstant.forgotPassword;

  const sendPassword = async (params: { login: string; oldPassword: string; newPassword: string; confirmPassword: string }) => {
    const loginFormData = new FormData();
    loginFormData.append('login', params.login);
    loginFormData.append('oldPassword', params.login);
    loginFormData.append('newPassword', params.login);

    if (params.newPassword !== params.confirmPassword) {
      showAlert({
        show: true,
        content: 'Verifique as novas senhas,elas devem ser iguais',
        color: 'warning',
        time: 2000,
      });
      return;
    }

    await new ForgotPasswordUseCase(`${ENDPOINT_FORGOT_PASSWORD}`)
      .Post({
        data: {
          login: params.login,
          oldPassword: params.oldPassword,
          newPassword: params.newPassword,
        },
      })
      .then((response) => {
        console.info('RESPONSE: ', response);
        if (response.statusCode !== undefined) {
          showAlert({
            show: true,
            content: 'Operação realizada com sucesso',
            color: 'success',
            time: 2000,
          });
        } else {
          showAlert({
            show: true,
            content: 'Ops!!! Algo deu errado tente novamente mais tarde...',
            color: 'danger',
            time: 2000,
          });
        }
        if (response.statusCode === 200) {
          localStorage.clear();
          navigate('/');
          // eslint-disable-next-line no-restricted-globals
          location.reload();
        }
      })
      .catch((error) => {
        showAlert({
          show: true,
          content: 'Ops!!! Algo deu errado tente novamente mais tarde...',
          color: 'danger',
          time: 2000,
        });
        console.error('ERRO: ', error);
      });
  };

  return (
    <>
      <ChangePasswordPage sendPassword={sendPassword} />
    </>
  );
};
